import baseHttpService from "core/http/singleton/base";

import {
  getListDocFormRes,
  getListAuthorizationDocsParams,
  getListAuthorizationDocsRes,
  getMenuRes,
} from "./resTypes";

import {
  getAuthorizationDocsUrl,
  getAuthorizationDocumentMenu,
  getAuthorizationDocumentDetailUrl,
  getDocFormUrl,
} from "./urls";

export const getAuthorizationDocumentMenuAPI = async (
  screenCode: string
): Promise<getMenuRes> => {
  const res = await baseHttpService.get<getMenuRes>(
    getAuthorizationDocumentMenu(screenCode)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getAuthorizationDocumentSubMenuAPI = async (params: {
  screenCode: string;
  id: string;
}): Promise<getMenuRes> => {
  const { screenCode, id } = params;
  const res = await baseHttpService.get<getMenuRes>(
    getAuthorizationDocumentMenu(screenCode),
    { fieldId: id }
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getAuthorizationDocumentDetailAPI = async (params: {
  screenCode: string;
  id: string;
}): Promise<any> => {
  const { screenCode, id } = params;
  const res = await baseHttpService.get<any>(
    getAuthorizationDocumentDetailUrl(screenCode, id)
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListAuthorizationDocsApi = async (
  payload: getListAuthorizationDocsParams
): Promise<getListAuthorizationDocsRes> => {
  const { params, screenCode } = payload;
  const res = await baseHttpService.get<getListAuthorizationDocsRes>(
    getAuthorizationDocsUrl(screenCode),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};

export const getListDocFormApi = async (
  payload: getListAuthorizationDocsParams
): Promise<getListDocFormRes> => {
  const { params, screenCode } = payload;
  const res = await baseHttpService.get<getListDocFormRes>(
    getDocFormUrl(screenCode),
    params
  );
  if (!res || !res.data) throw new Error("Some thing wrong");
  return res.data;
};
